import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setCalendarRange, resetCalendarRange } from 'modules/performance/actions';

export const useCalendarRange = () => {
  const dispatch = useDispatch();
  const calendarRangeRedux = useSelector((state) => state.calendarRange);
  // dates are persisted in ISO format (encoding timezone) so don't manipulate with them
  const { startDate, endDate } = calendarRangeRedux || {};

  const calendarRange = {
    ...calendarRangeRedux,
    startDate: new Date(startDate),
    endDate: new Date(endDate),
  };

  const setDate = (range) => dispatch(setCalendarRange(range));
  const resetDate = () => dispatch(resetCalendarRange());

  return useMemo(() => ({ calendarRange, setDate, resetDate }), [startDate, endDate]);
};

export default useCalendarRange;
